/* eslint-disable jsx-a11y/label-has-associated-control */
import { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';

import EmailChip from '../EmailChip/EmailChip';
import InputWithSuggestions from '../InputWithSuggestions/InputWithSuggestions';

import styles from './EmailsInput.module.scss';

import Button from '../../new_arch/components/Button/Button';
import ContactsGroupsModal from '../../new_arch/modules/workspaces/modals/ContactsGroupsModal/ContactsGroupsModal';
import Workspace from '../../entities/workspace';

const EmailsInput = forwardRef( ( {
	projectMemberRoleName, addedEmails, disabled, value, workspace,
	onChange, placeholder, onKeyDown, onDeleteEmail, onPaste, addEmailsFromGroups, name, autoComplete,
	showAddGroupButton, markAllEmailsAsInvalid = false
}, ref ) => {
	const [ shouldShowContactsGroupsModal, setShouldShowContactsGroupsModal ] = useState( false );

	const onAddContactsGroupClicked = () => setShouldShowContactsGroupsModal( true );

	const onCloseContactsGroupsModal = () => {
		setShouldShowContactsGroupsModal( false );
	}

	const addEmailsFromSelectedGroups = ( emails ) => {
		addEmailsFromGroups( emails );
		onCloseContactsGroupsModal();
	};

	return (
		<div className={styles.emailsInput}>
			<div className={styles.inviteesContainer}>
				<div className={styles.labelLine}>
					<label>Invite {projectMemberRoleName}</label>
				</div>
				<div className={styles.emailsInput}>
					{addedEmails.map( email => (
						<EmailChip
							key={email.value}
							isValid={!markAllEmailsAsInvalid && email.isValid}
							value={email.value}
							onDeleteEmail={onDeleteEmail}
						/>
					) )}
					<div className={styles.input}>
						<InputWithSuggestions
							ref={ref}
							name={name}
							value={value}
							disabled={disabled}
							onChange={event => onChange( event.target.value.trim() )}
							placeholder={placeholder}
							onKeyDown={onKeyDown}
							onPaste={onPaste}
							autoComplete={autoComplete}
							autoFocus
						/>
					</div>
				</div>
				{showAddGroupButton && (
					<>
						<Button
							className={styles.addGroupButton}
							type="text"
							onClick={onAddContactsGroupClicked}
						>
							+ add Group
						</Button>
						{shouldShowContactsGroupsModal && (
							<ContactsGroupsModal
								onClose={onCloseContactsGroupsModal}
								onConfirm={addEmailsFromSelectedGroups}
								workspace={workspace}
							/>
						)}
					</>
				)}
			</div>
		</div>
	);
} );

EmailsInput.propTypes = {
	projectMemberRoleName: PropTypes.string.isRequired,
	addedEmails: PropTypes.arrayOf( PropTypes.any ).isRequired,
	addEmailsFromGroups: PropTypes.func,
	disabled: PropTypes.bool,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	onKeyDown: PropTypes.func.isRequired,
	onDeleteEmail: PropTypes.func.isRequired,
	onPaste: PropTypes.func.isRequired,
	name: PropTypes.string.isRequired,
	autoComplete: PropTypes.string.isRequired,
	workspace: PropTypes.instanceOf( Workspace ).isRequired,
	showAddGroupButton: PropTypes.bool,
	markAllEmailsAsInvalid: PropTypes.bool
};

EmailsInput.defaultProps = {
	disabled: false,
	placeholder: ''
};

export default EmailsInput;
